import React from "react";
import { useTranslation } from "react-i18next";
// import Tilt from "react-parallax-tilt";
import { motion } from "framer-motion";
import doctor1 from "../assets/doctors/doctor1.jpg";
import doctor2 from "../assets/doctors/doctor2.jpg";
// import doctor3 from "../assets/doctors/doctor3.jpg";
import about from "../assets/about.jpg";


 

const AboutUs = () => {
  const { t } = useTranslation();
  
  const doctors = [
    {
      name: t("doctorsname.0.name"),
      title: t("doctorsname.0.title"),
      image: doctor1,
    },
    {
      name: t("doctorsname.1.name"),
      title: t("doctorsname.1.title"),
      image: doctor2,
    },
  ]
  return (
    <section id="about" className="py-20 bg-gradient-to-br from-blue-100 via-white to-pink-100 px-4">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-12 mb-20">
      {/* <Tilt
  glareEnable={true}
  glareMaxOpacity={0.3}
  scale={1.05}
  transitionSpeed={2500}
> */}
        {/* Hospital Image */}
        <motion.div
          className="w-95 h-95 overflow-hidden rounded-3xl shadow-2xl group"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <img
            src={about}
            alt="Hospital Building"
            className="w-full h-full object-cover rounded-3xl transform group-hover:scale-110 transition-transform duration-700 ease-in-out"
    whileHover={{ scale: 1.05 }}

          />
        </motion.div>
        {/* </Tilt> */}
        {/* About Text */}
        <motion.div
          className="max-w-xl text-left"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <motion.h2
            className="text-4xl md:text-5xl font-bold text-purple-700 mb-6 drop-shadow-lg"
            initial={{ opacity: 0, y: -30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {t("about_title")}
          </motion.h2>

          <motion.p
            className="text-gray-800 text-lg md:text-xl leading-relaxed text-justify"
            dangerouslySetInnerHTML={{ __html: t("about_detailed") }}
          ></motion.p>
        </motion.div>

      </div>

      {/* Doctors Section */}
      <div className="max-w-7xl mx-auto text-center">
        <motion.h3
          className="text-3xl md:text-4xl font-bold text-purple-700 mb-12"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {t("our_doctors")}
        </motion.h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12">
          {doctors.map((doc, idx) => (
            <motion.div
              key={idx}
              className="relative bg-gradient-to-br from-white via-gray-100 to-purple-50 rounded-3xl overflow-hidden shadow-2xl border-2 border-purple-100 hover:shadow-purple-400 hover:border-purple-400 transition-all duration-500 p-8 flex flex-col items-center group hover:scale-105 hover:bg-gradient-to-tr from-pink-100 via-purple-100 to-blue-100"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.2 }}
            >
              <div className="w-44 h-44 rounded-2xl overflow-hidden border-4 border-purple-200 group-hover:scale-110 transition-transform duration-500 shadow-md">
                <img
                  src={doc.image}
                  alt={doc.name}
                  className="w-full h-95 object-cover rounded-2xl"
                />
              </div>
              <h4 className="text-2xl font-semibold text-purple-800 mt-6 group-hover:text-purple-600 transition-colors duration-300">
                {doc.name}
              </h4>
              <p className="text-gray-600 text-lg mt-2 group-hover:text-purple-500 transition-colors duration-300">
                {doc.title}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
